// extracted by mini-css-extract-plugin
export default {"block":"Uh","select":"Vh","empty":"Wh","open":"Xh","error":"Yh","options":"Zh","selectActive":"_h","ornament":"ai"};